import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnUser } from '@lib/api/entities';

import { SnChannelsService } from '../../../services/channels.service';

export interface ISnChannelFormDialogData {
  type: 'organization' | 'direct';
  userId: string;
  users?: SnUser[];
}

@Component({
  templateUrl: './channel-form.dialog.html',
})
export class SnChannelFormDialogComponent implements OnDestroy {
  public readonly type: 'organization' | 'direct';
  public readonly userId: string;
  public users: SnUser[];

  public isLoading = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ISnChannelFormDialogData,
    private readonly _matDialogRef: MatDialogRef<SnChannelFormDialogComponent>,
    private readonly _channelsService: SnChannelsService,
    private readonly _toastrService: ToastrService,
    private readonly _cd: ChangeDetectorRef,
  ) {
    this.type = data.type;
    this.userId = data.userId;
    this.users = data.users;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onDialogSent(channelData: Object): void {
    const request$ =
      this.type === 'organization'
        ? this._channelsService.createOrganizationChannel(channelData)
        : this._channelsService.createDirectChannel(channelData);

    this.isLoading = true;

    request$
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => (this.isLoading = false)),
      )
      .subscribe({
        next: (chat) => {
          this._matDialogRef.close(chat);
          this._cd.detectChanges();
        },
        error: (err) => {
          this._toastrService.error(`${err.error.name[0]}`, 'ERROR');
        },
      });
  }
}
